import React, { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import About from "./Pages/About";
import Home from "./Pages/Home";
import Experience from "./Pages/Experience";
import NotFound from "./Pages/NotFound";
import Work from "./Pages/Work";
import ReactGA from "react-ga";
const TRACKING_ID = process.env.REACT_APP_TRACKING_ID;
ReactGA.initialize(TRACKING_ID);

function App() {
    const navigate = useNavigate();

    useEffect(() => {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, [navigate]);

    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/works" element={<Work />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

export default App;
